$(function () {
  if (!customElements.get('member-faq')) {
    customElements.define(
      'member-faq',
      class MemberFaq extends HTMLElement {
        constructor() {
          super();
          this.$element = $(this);
          this.handleResize = this.handleResize.bind(this);
          this.bindEvents();
        }

        bindEvents() {
          $(window).on('resize', this.handleResize);
          this.$element.on('click', '.faq-trigger', this.toggleFAQ.bind(this));
        }

        disconnectedCallback() {
          $(window).off('resize', this.handleResize);
          this.$element.off('click', '.faq-trigger');
        }

        toggleFAQ(event) {
          const $trigger = $(event.currentTarget);
          const $item = $trigger.closest('.faq-item');
          const $answer = $trigger.siblings('.faq-answer');
          const $content = $answer.children();

          // 关闭其他所有打开的FAQ
          this.$element.find('.faq-answer').not($answer).css('height', '0');
          this.$element.find('.faq-item').not($item).removeClass('active');

          // 切换当前FAQ的状态
          if ($answer.height() > 0) {
            $answer.css('height', '0');
            $item.removeClass('active');
          } else {
            const height = $content.outerHeight();
            $answer.css('height', height + 'px');
            $item.addClass('active');
          }
        }

        handleResize() {
          const $openAnswer = this.$element.find('.faq-answer').filter(function () {
            return $(this).height() > 0;
          });

          if ($openAnswer.length) {
            const height = $openAnswer.children().outerHeight();
            $openAnswer.css('height', height + 'px');
          }
        }
      }
    );
  }
});
